import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {clearError} from '../services/actions';
import {getSetupError} from '../services/selectors';

import type {Error} from 'src/openapi/admin/models/Error';

export const useError = () => {
    const dispatch = useDispatch();
    const error: Error | null = useSelector(getSetupError);

    const setError: () => void = useCallback(() => {
        dispatch(clearError());
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return {error, setError};
};
